export default "__VITE_ASSET__CEp2EItB__"